import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import InstagramFeed  from 'react-ig-feed';
import InstagramEmbed from 'react-instagram-embed';
// import 'react-ig-feed/dist/index.css'

import * as commonActionCreators from '../../../../actions/common';
let allActionCreators = Object.assign({}, commonActionCreators);

class ProductSocial extends React.Component {

	static propTypes = {
		location: PropTypes.object
	};

	static contextTypes = {
		store: PropTypes.any,
		router: React.PropTypes.object.isRequired
	};

	constructor(props) {
		super(props);
		this.state = {};
	}

	componentDidMount() {
		// var feed = new Instafeed({
  //     accessToken: 'EAAFA6QMYig8BAA0Jwnif01t9gOF9gqZBXtT2yX3udi01zUtPnGj9DGMirmDKjln1WWkjxA8gnUnpf6XZBQCx4P0E3U8KcZAXZB8ZBg3SIKmurO6WzmTtFJZArZCrIDZAipOmmHCd2B2I9ZAfJWJwsfgshDzOWhfvFffvkuqRIRCW30aQvwzTbbnAlmkXA7A1gco8xHciptg0ngFXXH6FA0vgu'
  //   });
  //   console.log(feed);
  //   feed.run();
	}

	internalNav(page) {
		this.context.router.push('/' + page);
	}

	externalNav(page) {
		window.location.href = '/' + page;
	}

	openNew(page) {
		let win = window.open(page, '_blank');
		win.focus();
	}

	// 352844500208143
	// 20ecbdea627b6960a68cd59a7628f7b1

	// a612d94186390a5e05a10ccd1a4c53e3

	// EAAFA6QMYig8BAA0Jwnif01t9gOF9gqZBXtT2yX3udi01zUtPnGj9DGMirmDKjln1WWkjxA8gnUnpf6XZBQCx4P0E3U8KcZAXZB8ZBg3SIKmurO6WzmTtFJZArZCrIDZAipOmmHCd2B2I9ZAfJWJwsfgshDzOWhfvFffvkuqRIRCW30aQvwzTbbnAlmkXA7A1gco8xHciptg0ngFXXH6FA0vgu

	// from RH
	// IGQVJXWWFKOU81aUd3WjZAkdEJGQzhRSnF1TExRdnUyQ2Uxc0lNLTJFbW5DNWRVdTJENkpXVTNGT2tyb1ZArSmV1eTdvNnk0eDg0UnItRzRLSFpzcnhJT0haX2o4alZAERzlHbFp0REFSWFlYekdUb29WcQZDZD

	
	// 			<div className='igWrapper'>
	// 				<InstagramEmbed
	// 				  url='https://www.instagram.com/diamondsdirect'
	// 				  clientAccessToken='514122350324351|a612d94186390a5e05a10ccd1a4c53e3'
	// 				  maxWidth={320}
	// 				  hideCaption={false}
	// 				  containerTagName='div'
	// 				  protocol=''
	// 				  injectScript
	// 				  onLoading={() => {}}
	// 				  onSuccess={() => {}}
	// 				  onAfterRender={() => {}}
	// 				  onFailure={() => {}} />
	// 			</div>
	// 			<div id="instafeed"></div>

	// IGQVJXWWFKOU81aUd3WjZAkdEJGQzhRSnF1TExRdnUyQ2Uxc0lNLTJFbW5DNWRVdTJENkpXVTNGT2tyb1ZArSmV1eTdvNnk0eDg0UnItRzRLSFpzcnhJT0haX2o4alZAERzlHbFp0REFSWFlYekdUb29WcQZDZD

	// IGQVJVLU1IMjZAjZAkRkbWFkeWJPLVJNYzBKOVlyVWVYZAmotX2pOX3ZAvLVdNTHJDNzd2V2dPZAlM1UVE1TXBjUjM4ZA0dGVlY3WXVHUUlBZA2pkSjlWeDNWMkotbVFteTU1b3I2dHBfREw2ZA09TdjlWTFBmVgZDZD

	render() {
		return <div className='ProductSocial'>
			<div className='socialTitle'>Diamonds Direct on Social</div>
			<div className='socialImagesWrapper'>
				<div className='igWrapper'>
					<InstagramFeed token="IGQVJVLU1IMjZAjZAkRkbWFkeWJPLVJNYzBKOVlyVWVYZAmotX2pOX3ZAvLVdNTHJDNzd2V2dPZAlM1UVE1TXBjUjM4ZA0dGVlY3WXVHUUlBZA2pkSjlWeDNWMkotbVFteTU1b3I2dHBfREw2ZA09TdjlWTFBmVgZDZD"  counter="6" />
				</div>
			</div>
		</div>;
	}
}
export default ProductSocial;

function mapStateToProps(state) {
	return {

	};
}

export const ProductSocialContainer = connect(
	mapStateToProps,
	allActionCreators
)(ProductSocial);


// WEBPACK FOOTER //
// ./src/components/views/product-page/blocks/ProductSocial.jsx